// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"240":"b25a9e6f","696":"a7a53302"}[chunkId] + ".chunk.css";
};